import { Expose, Type } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

export class HouseholdClaimCoverage extends BaseModel {
    @Expose() id = 0;
    @Expose() level = 0;
    @Expose() order = 0;
    @Expose() label = "";
    @Expose()
    excluding: number[] = [];
    @Expose()
    @Type(() => HouseholdClaimCoverage)
    children: HouseholdClaimCoverage[] = [];
}
